import { ArrowRight, Heart, Sparkles } from "lucide-react";
import { ENAGA_PHOTOS } from "@/lib/localMedia";
import { useDonation } from "@/context/DonationContext";
import CountUp from "./CountUp";

export default function Hero() {
  const { openModal } = useDonation();

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] overflow-hidden bg-ga-ink"
    >
      <div className="absolute inset-0">
        <img
          src={ENAGA_PHOTOS.acolhimento}
          alt="Equipe do Instituto ENAGA acolhendo crianças em sala segura e preparada."
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ga-ink via-ga-ink/85 to-ga-ink/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-ga-ink via-ga-ink/10 to-transparent" />
      </div>

      <div className="relative container-ga pt-32 pb-20 sm:pt-40 sm:pb-28 min-h-[100svh] flex flex-col justify-center">
        <div className="max-w-3xl">
          <div
            className="pill border-white/25 text-white/85 bg-white/5 mb-8"
            data-testid="hero-tagline"
          >
            <Sparkles className="w-3.5 h-3.5 text-ga-amber" />
            Fé • Amor • Saúde integral
          </div>

          <h1
            className="text-white font-display font-black tracking-tighter leading-[0.98] text-5xl sm:text-6xl lg:text-7xl"
            data-testid="hero-headline"
          >
            Cuidando de vidas com{" "}
            <span className="text-ga-amber">fé</span>, amor e{" "}
            <span className="text-ga-emerald">saúde</span>.
          </h1>

          <p
            className="mt-7 text-lg sm:text-xl text-white/85 max-w-2xl leading-relaxed"
            data-testid="hero-subhead"
          >
            Transformamos pessoas por meio do cuidado espiritual e da promoção
            da saúde integral, atendendo famílias, crianças e comunidades que
            mais precisam.
          </p>

          <div
            className="mt-10 flex flex-wrap gap-3"
            data-testid="hero-ctas"
          >
            <button
              type="button"
              onClick={() => openModal("hero")}
              className="btn-primary"
              data-testid="hero-btn-donate"
            >
              <Heart className="w-5 h-5" />
              Doe agora
              <ArrowRight className="w-4 h-4" />
            </button>
            <a
              href="#pilar-cristao"
              className="btn-outline"
              data-testid="hero-btn-projects"
            >
              Conheça nossos projetos
            </a>
          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-3xl">
            {[
              { n: 3487, prefix: "+", v: "Famílias atendidas por ano" },
              { n: 2517, prefix: "+", v: "Atendimentos de saúde" },
              { n: 31, v: "Nossas unidades Jaboatão dos Guararapes - PE" },
              { n: 6, v: "Anos proporcionando esperança para famílias com (TEA)" },
            ].map((s) => (
              <div key={s.v} className="text-white/90" data-testid={`hero-stat-${s.v.replace(/\s/g, '-').toLowerCase()}`}>
                <div className="font-display font-black text-3xl sm:text-4xl text-white tabular-nums">
                  {s.prefix || ""}<CountUp to={s.n} duration={1400} />
                </div>
                <div className="text-sm text-white/60 mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
